import React from 'react';
import styled from '@emotion/styled';

import AcceptAgreementForm from './AcceptAgreementForm';
import Logo from '../../../shared/images/full-logo-black-orange.png';
import SubText from '../../../shared/_TBComponents/SubText';

const FormArea = styled('div')`
  padding: 30px 54px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const FormContainer = styled('div')`
  width: 500px;
  height: auto;
  background-color: white;
  padding-bottom: 40px;

  @media screen and (max-width: 600px) {
    width: 330px;
    height: auto;
    padding-bottom: 20px;
  }
`;

const TitleArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 2px solid rgb(232, 232, 232);
  height: 160px;
  align-items: center;
  padding: 30px 80px 5px 80px;
  justify-content: center;

  img {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    height: 135px;
  }
`;

const AcceptAgreementContainer = () => (
  <FormContainer>
    <TitleArea>
      <img alt='Teambuildr' className='img-fluid' src={Logo} />
      <SubText color='text'>Accept Agreement</SubText>
    </TitleArea>
    <FormArea>
      <AcceptAgreementForm />
    </FormArea>
  </FormContainer>
);

export default AcceptAgreementContainer;
